import currency from '@/libs/currency'

export default {
    state:{
        idventa:false,
    },
    mutations:{
        setIdVenta(state,item){
            state.idventa=item
        },
        setTotalVenta(state,totalfactura){
            state.idventa.Total = currency(totalfactura,2).value
        },
        setTotalIva(state,iva){
            state.idventa.IVA = iva
        }
    },
    actions:{
        setIdVenta({commit},item){
            commit("setIdVenta",item)
        },
        setTotalVenta({commit},totalfactura){
            commit("setTotalVenta",totalfactura)
        },
        setTotalIva({commit},iva){
            commit("setTotalIva",iva)
        }
    },
    getters:{
        getIdVenta(state){
            return state.idventa
        },
        getIdRegimen(state){
            return state.idregimen
        }
    }
}